import {State} from '../reducers';
import {Experiment} from '../reducers/experiments';

export const experimentsSelector = (state: State): Experiment[] => state.experiments.active;
